export default "__VITE_ASSET__D_VYeZC0__"